import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getTimesheet = async ({
  companyCode,
  locationCode,
  employeeCode,
  isAllCompanies = false,
  userId = 0,
  selectedCompanyCode = "",
  year = 0,
  month = 0,
}) => {
  if (companyCode && locationCode) {
    let url = `${Api_EndPoints.GetTimesheetData}?isAllCompanies=${isAllCompanies}&CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&Year=${year}&Month=${month}&Locationcode=${locationCode}`;

    if (employeeCode) {
      url += `&EmployeeCode=${employeeCode}`;
    }
    if (isAllCompanies && userId) {
      url += `&UserId=${userId}`;
    }
    const { data } = await http_payroll.get(url);
    return data;
  }
  return [];
};

export const useGetTimesheetDataQuery = (filter) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetTimesheetData, filter],
    queryFn: () => getTimesheet(filter),
    // staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
